import React, { useEffect, useState } from 'react'
import CustomDate from 'designer/component/element/Date'
import moment from 'moment'
import { DEFAULT_DATE } from 'designer/component/action/Date'

const DateControl = (props) => {
  const { uischema, handleChange, path, config } = props
  const data = config?.jsonData
  const { defaultType } = uischema
  const [initial, setInitial] = useState(null)

  const updateData = (date) => {
    let value = null
    if (date?.value) {
      value = moment(date.value).format('YYYY-MM-DD')
    }
    updateValue(value)
  }

  const updateValue = async (value) => {
    handleChange(path, value)
  }

  const defaultDate = {
    ...DEFAULT_DATE,
    custom: uischema.defaultValue,
  }

  useEffect(() => {
    if (initial) return
    if (!data && defaultType) {
      updateValue(defaultDate[defaultType])
      setInitial(true)
    }
  }, [data])

  return (
    <CustomDate
      {...props}
      uischema={uischema}
      value={data}
      updateData={updateData}
    />
  )
}

export default DateControl
